<template>
  <div class="cus-cascade">
    <custom-select
        v-model="vModel[0]"
        placeholder="请选择"
        :options="selectOption.options"
        style="width: fit-content; color: #697B8C; margin-left: 10px"
        @visible-change="closePopover"
        @change="hidePopover(true)"
    />

    <el-popover
        style="flex: 1; min-width: 0;"
        ref="popoverRef"
        @show="showPopover"
        @hide="hidePopover"
        :disabled="(vModel[0]==''&&flag==true)"
        popper-class="select-tab-pop"
        :visible-arrow="false"
        placement="bottom-start"
        trigger="click">
      <div slot="reference" class="reference-slot" @mouseout="()=>{this.showDelete = false}"
        :style="{cursor:flag==true?'auto':'pointer'}"
           @mouseover="()=>{this.showDelete = true}">
        <span class="placeholder">{{placeholder}}</span>
        <div class="input-val" >{{ inputValue("name") }}</div>
        <div class="input-num" v-show="inputValue('num') > 0">{{ "+" + inputValue("num") }}</div>
        <div class="delete-icon">
          <i class="el-icon-circle-close" @click="clearInput" v-show="showDelete"></i>
        </div>
        <i :class="icon" style="margin-left: 8px; margin-right: 8px"></i>
      </div>

      <div class="ca-content">
        <div class="select-tab">
          <template v-for="(item, index) in searchOption">
            <div class="options-box" v-if="index === 0 || (!$tool.empty(vModel[index]) && !$tool.empty(searchResult[index]))">
              <el-input
                  size="small"
                  :placeholder="item.placeholder ? item.placeholder : '请输入'"
                  prefix-icon="el-icon-search"
                  :value="searchValue[index + 1]"
                  clearable
                  @input="(v)=>setSearchValue(v, index+1)"
                  v-if="item.isSearch"
                  :ref="`input-${index}`"
              >
              </el-input>
              <div class="select-content">
                <div v-for="item2 in searchResult[index+1]" :class="getActiveClass(item2, index+1)"
                     :style="item.isSearch ? 'margin-top: 2px' : ''" @click="execVmodel(item2, index+1, item)">
                  {{ item2 }}
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="cs-submit-btn">
          <div @click="submit">确认</div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import requests from "@/utils/requests";
import CustomSelect from "@/components/customSelect/index.vue";

export default {
  name: "CascadeSelect",
  components: {CustomSelect},
  props: {
    flag:{
      type:Boolean,
      default:false

    },
    value:{
      type: Array,
      default: []
    },
    placeholder:{
      type: String,
      default: "请选择"
    },
    selectOption: {
      type: Object,
      default: () => {
        return {
          // options: [
          //   {
          //     value: "",
          //     label: '全部批次'
          //   },
          //   {
          //     value: 1,
          //     label: '首批'
          //   }, {
          //     value: 2,
          //     label: '2批'
          //   }, {
          //     value: 3,
          //     label: '3批'
          //   }
          // ],
          // searchField: "investBatch",
        }
      }
    },
    searchOption: {
      type: Array,
      default: () => {
        return [
          // {
          //   url: "xxxxx",
          //   searchField: "brand",
          //   multiple: true,
          //   isSearch: true,
          //   defaultValue: "",
          // },
          // {
          //   url: "xxxxx",
          //   searchField: "company",
          //   multiple: false,
          //   isSearch: false,
          //   defaultValue: "",
          // },
          // {
          //   url: "xxxxx",
          //   searchField: "shop",
          //   multiple: true,
          //   isSearch: true,
          //   defaultValue: "",
          // },
        ]
      }
    }
  },
  data() {
    return {
      first: true,
      showDelete: false,
      icon: "el-icon-arrow-down",
      vModel: {
        0: "",
        1: "",
        2: "",
        3: "",
      },
      searchValue: {
        1: "",
        2: "",
        3: "",
      },
      searchResult: {
        1: [],
        2: [],
        3: [],
      },
    }
  },
  mounted() {

  },
  computed: {
    inputValue() {
      return (key) => {
        let copyModel = _.cloneDeep(this.value)
        let oldArr = [copyModel[1], copyModel[2], copyModel[3]]
        let res = this.$tool.cartesianProduct(oldArr)
        let str = ""
        let num = 0
        if (!this.$tool.empty(res)) {
          str = res[0].join(" - ")
          num = res.length - 1
        }
        return key === "name" ? str : num
      }
    }
  },
  watch: {
    "vModel.0": { // 批次
      handler(v) {
        this.searchValue = {
          1: "",
          2: "",
          3: "",
        }
        this.searchResult = {
          1: "",
          2: "",
          3: "",
        }
        if(!this.first){
          this.vModel[1] = ""
          this.vModel[2] = ""
          this.vModel[3] = ""
        }
      }
    },
    "vModel.1": { // 品牌
      handler(v) {
        this.searchValue[2] = ""
        this.searchValue[3] = ""
        this.searchResult[2] = ""
        this.searchResult[3] = ""
        if (!this.$tool.empty(v)) {
          this.remoteSearch(2)
        }
      },
      deep: true
    },
    "vModel.2": { // 公司
      handler(v) {
        this.searchValue[3] = ""
        this.searchResult[3] = ""
        if (!this.$tool.empty(v)) {
          this.remoteSearch(3)
        }
      },
      deep: true
    },
    value: {
      handler(v) {
        this.first = true
        v.forEach((val, idx)=>{
          if(idx > 0 && val){
            this.getInitSearchResult(idx)
          }
          this.vModel[idx] = val
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submit(){
      this.closePopover()
    },
    showPopover(){
      this.icon = 'el-icon-arrow-up'
      this.first = false
      this.$nextTick(function () {
        this.$refs["input-0"][0].focus()
      })
    },
    hidePopover: _.debounce(function (clear = false){
      this.icon = 'el-icon-arrow-down'

      let value = []
      Object.keys(this.vModel).forEach((key, idx)=>{
        if(value.length < this.searchOption.length + 1)
        {
          if(clear){
            value.push(idx === 0 ? this.vModel[key] : "")
          }else{
            value.push(this.vModel[key])
          }
        }
      })
      this.$emit("change", value)
      this.$emit("input", value)
    }, 100),
    getActiveClass(v, field) {
      // 条目选中的值
      let selectValue = _.cloneDeep(this.vModel[field])
      if (!Array.isArray(selectValue)) {
        selectValue = [selectValue]
      }
      return selectValue.indexOf(v) > -1 ? "item active" : "item"
    },
    setVmodel(v, field) {
      this.vModel[field] = v
    },
    remoteSearch: _.debounce(async function (field, isSearch = false) {
      if(!this.first){
        this.vModel[field] = ""
      }
      if (!this.searchOption[field - 1] || (!isSearch && this.searchOption[field - 1].isSearch)) {
        // 不是搜索，要判断 isSearch true 直接置为空
        this.searchResult[field] = []
        return
      }
      // 设置搜索要传的参数
      let param = {
        search: isSearch ? this.searchValue[field] : ""
      }
      let copyVmodel = _.cloneDeep(this.vModel)
      param[this.selectOption.searchField] = copyVmodel[0]
      this.searchOption.forEach((val, idx) => {
        param[val.searchField] = !Array.isArray(copyVmodel[idx + 1]) && !this.$tool.empty(copyVmodel[idx + 1]) ? [copyVmodel[idx + 1]] : copyVmodel[idx + 1]
      })
      // console.log(param)

      let res = await requests.request({
        url: this.searchOption[field - 1].url,
        method: "post",
        data: param
      });
      // let res = {}
      // res.data = [
      //     1,2,3,4,5,6,7,8
      // ]
      this.searchResult[field] = res.data
      if (this.searchOption[field - 1].defaultValue) {
        switch (this.searchOption[field - 1].defaultValue) {
          case "first":
            this.execVmodel(this.searchResult[field][0], field, this.searchOption[field - 1])
            break
          case "all":
            this.vModel[field] = this.searchResult[field]
            break
        }
      }
    }, 200),
    async getInitSearchResult(field){
      // 初始时获取result
      if(!this.$tool.empty(this.searchResult[field])) return
      let param = {}
      let copyVmodel = _.cloneDeep(this.vModel)
      param[this.selectOption.searchField] = copyVmodel[0]
      this.searchOption.forEach((val, idx) => {
        param[val.searchField] = !Array.isArray(copyVmodel[idx + 1]) && !this.$tool.empty(copyVmodel[idx + 1]) ? [copyVmodel[idx + 1]] : copyVmodel[idx + 1]
      })

      let res = await requests.request({
        url: this.searchOption[field - 1].url,
        method: "post",
        data: param
      });
      this.searchResult[field] = res.data
    },
    setSearchValue(v, field) {
      this.searchValue[field] = v
      // 搜索时，搜索框后面的vModel要置为空
      let i = field
      while (i <= this.searchOption.length - 1) {
        i++
        this.searchValue[i] = ""
        if (this.searchOption[i - 1].multiple) {
          this.vModel[i] = []
        } else {
          this.vModel[i] = ""
        }
      }
      this.remoteSearch(field, true)
    },
    execVmodel(v, field, item) {
      if (item.multiple) {
        if (!Array.isArray(this.vModel[field])) this.vModel[field] = []
        let index = this.vModel[field].indexOf(v)
        if (index > -1) {
          // 刪除
          this.vModel[field].splice(index, 1)
        } else {
          // 添加
          this.vModel[field].push(v)
        }
      } else {
        //
        this.vModel[field] = this.vModel[field] === v  ? "" : v
      }
    },
    closePopover() {
      this.$refs.popoverRef.doClose()
    },
    clearInput(e) {
      this.closePopover()
      // 清空vModel
      this.vModel[1] = ""
      this.vModel[2] = ""
      this.vModel[3] = ""
      this.searchValue[1] = ""
      this.searchValue[2] = ""
      this.searchValue[3] = ""
      this.searchResult = {
        1: [],
        2: [],
        3: [],
      }
      this.hidePopover()
      e.stopPropagation()
    }
  }
}
</script>

<style scoped lang="less">
@import "/src/style/variables";
.reference-slot {
  display: flex;
  align-items: center;
  color: #D9D9D9;
  height: 32px;
  font-size: 14px;
  cursor: pointer;
  min-width: 0;

  .placeholder {
    margin: 0 8px;
    white-space: nowrap;
  }

  .input-val {
    color: #606266;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0;
    flex: 1
  }

  .input-num {
    color: #D9D9D9;
  }

  .delete-icon {
    width: 16px;
    text-align: center;
    margin-left: 8px
  }
}

.cus-cascade {
  flex: 1;
  display: flex;
  border-radius: 4px;
  padding: 0 2px;
  border: 1px solid rgba(255,255,255,0.8);
  box-sizing: border-box;
  height: 32px;
  align-items: center;
}

.select-tab {
  display: flex;

  .options-box {
    padding: 0 2px;
    border-right: 1px solid #D9D9D9;
    width: 220px;

    .item {
      min-width: 200px;
      line-height: 32px;
      margin-bottom: 2Px;
      padding: 0 14px;
      cursor: pointer;
    }

    .active {
      background: #EFF4FF;
      border-radius: 6px;
      color: @--color-primary;
    }
  }

  .options-box:last-child {
    padding-right: 0;
    border-right: unset;
  }

  .select-content {
    height: 200px;
    overflow-y: auto;
  }

  .select-content::-webkit-scrollbar {
    display: none;
  }
}

::v-deep .el-input__inner {
  border: none;
  height: 29px;
}

::v-deep .el-select {
  border-right: 1px solid #D9D9D9;
}

::v-deep .options-box .el-input__inner {
  border: 1px solid #D9D9D9;
}
.select-tab ::v-deep .el-popover__reference-wrapper{
  flex: 1;
  min-width: 0;
}
.ca-content{
  .cs-submit-btn{
    float: right;
    margin-top: 10px;
    div{
      width: 60px;
      height: 28px;
      background: @--color-primary;
      border-radius: 4px;
      text-align: center;

      font-size: 14px;
      color: #FFFFFF;
      line-height: 28px;

      cursor: pointer;
    }
  }
}

</style>
<style>
.select-tab-pop {
  margin-left: 0px !important;
  margin-top: 4px !important;
}
</style>